import { useDialogVisibilityByName } from '@patrianna/dialog-manager'
import { useIsMobile } from '@patrianna/shared-hooks'
import type { GameProduct } from '@patrianna/shared-patrianna-types/store/GameModule'
import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import type { ReactNode } from 'react'

import GameNotAvailable from 'pageContainers/GameNotAvailable'
import LogInToAccess from 'pageContainers/LogInToAccess'
import content from 'prismic-translates/common.json'
import { useAppSelector } from 'src/store/hooks'
import { isLegalsUpdatedAvailableSelector } from 'src/store/modules/appConfig/selectors'
import { getUserSubscriptionsSelector, getUserXpLevelSelector, isLoggedInSelector } from 'store/modules/user/selectors'

import GameBackground from '../components/GameBackground'

import classes from './styles.module.scss'
import useShowDialogOnlyScMode from './useShowDialogOnlyScMode'

const t = getTranslationFromJson([content])

type Props = {
  gameProduct: GameProduct
  children: ReactNode
}

export default function GameValidateWrapper(props: Props) {
  const { gameProduct, children } = props
  const isMobile = useIsMobile()
  const showDialogGameOnlyScMode = useShowDialogOnlyScMode(gameProduct)
  const isLoggedIn = useAppSelector(isLoggedInSelector)
  const xpLevel = useAppSelector(getUserXpLevelSelector)
  const isVipSubscription = useAppSelector(getUserSubscriptionsSelector)
  const isShopDialogOpened = useDialogVisibilityByName('SHOP_DIALOG')
  const isLegalsUpdateAvailable = useAppSelector(isLegalsUpdatedAvailableSelector)
  const levelRestricted = !isVipSubscription && gameProduct?.fromLevel > xpLevel?.level

  if (!isLoggedIn) {
    return (
      <GameBackground gameProduct={gameProduct}>
        <LogInToAccess classNameRoot={classes.logoutView} />
      </GameBackground>
    )
  }

  if (isLoggedIn && levelRestricted) {
    return (
      <GameBackground gameProduct={gameProduct}>
        <GameNotAvailable
          content={{
            title: `${t('game_unlocked')} ${gameProduct?.fromLevel}`,
            description: `${t('currently_level')} ${xpLevel?.level}. ${t('keep_going')}`,
            buttonText: t('go_to_home_page'),
          }}
          classNameRoot={classes.logoutView}
        />
      </GameBackground>
    )
  }

  if (isLegalsUpdateAvailable || showDialogGameOnlyScMode) {
    return <GameBackground gameProduct={gameProduct} className={classes.goldenView} />
  }

  if (isShopDialogOpened && isMobile) {
    return null
  }

  return <>{children}</>
}
